<template>
  <div class="consultations-info">
    <div
      v-if="!totalCount && isAllItemsLoaded"
      class="no-consultations"
    >
      <span>Нет консультаций</span>
    </div>
    <template
      v-else
    >
      <async-list
        :is-all-items-loaded="isAllItemsLoaded"
        :disable-toggle-header="true"
        class="consultations-list"
        @load-more-items="loadMoreItems"
      >
        <div
          v-for="consultation in consultations"
          :key="consultation.id"
          class="crm-container"
        >
          <PatientDetailConsultationsItem
            :consultation="consultation"
            :class="{ active: activeConsultation && consultation.id === activeConsultation.id }"
            @click.native="setActiveConsultation(consultation)"
          />
        </div>
      </async-list>

      <PatientDetailConsultation
        v-if="activeConsultation"
        :patient-id="patientId"
        :consultation="activeConsultation"
      />
      <div
        v-if="!activeConsultation"
        class="no-active-consultation"
      >
        Выберите консультацию из списка слева, чтобы посмотреть полную информацию о ней
      </div>
    </template>
  </div>
</template>

<script>
import AsyncList from '@/components/AsyncList';
import PatientDetailConsultationsItem from '@/components/Patients/PatientDetailConsultationsItem';
import PatientDetailConsultation from '@/components/Patients/PatientDetailConsultation';

const LIMIT = 15;

export default {
  name: 'PatientDetailConsultations',
  components: {
    AsyncList,
    PatientDetailConsultationsItem,
    PatientDetailConsultation,
  },
  props: {
    patientId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      limit: LIMIT,
    };
  },
  computed: {
    activeConsultation: {
      get() {
        return this.$store.state.Patients.detailConsultations.activeConsultation;
      },
      set(newVal) {
        this.$store.commit(this.$types.PATIENT_DETAIL_ACTIVE_CONSULATION_SET, newVal);
      },
    },
    isAllItemsLoaded: {
      get() {
        return this.$store.state.Patients.detailConsultations.isAllItemsLoaded;
      },
      set(newVal) {
        this.$store.commit(this.$types.PATIENT_DETAIL_CONSULATIONS_IS_ALL_ITEMS_LOADED_SET, newVal);
      },
    },
    isLoading: {
      get() {
        return this.$store.state.Patients.detailConsultations.isLoading;
      },
      set(newVal) {
        this.$store.commit(this.$types.PATIENT_DETAIL_CONSULATIONS_IS_LOADING_SET, newVal);
      },
    },
    consultations: {
      get() {
        return this.$store.state.Patients.detailConsultations.consultations;
      },
      set(newVal) {
        this.$store.commit(this.$types.PATIENT_CONSULTATIONS_SET, newVal);
      },
    },
    totalCount() {
      return this.consultations.length;
    },
  },
  created() {
    this.consultationsFetch(true);
  },
  beforeDestroy() {
    this.consultations = [];
    this.isAllItemsLoaded = false;
    this.activeConsultation = null;
  },
  methods: {
    async consultationsFetch(clear) {
      if (clear) this.consultations = [];

      this.isAllItemsLoaded = false;
      this.isLoading = true;

      const prevTotal = this.totalCount;

      try {
        await this.$store.dispatch(this.$types.PATIENT_CONSULTATIONS_FETCH, {
          skip: prevTotal,
          take: this.limit,
          patientId: this.patientId,
        });

        if (clear && this.consultations.length) {
          this.setActiveConsultation(this.consultations[0]);
        }

        if (prevTotal + this.limit > this.totalCount) {
          this.isAllItemsLoaded = true;
        }
      } catch (e) {
        console.warn(e);
      } finally {
        this.isLoading = false;
      }
    },
    loadMoreItems() {
      if (!this.isLoading) {
        this.consultationsFetch();
      }
    },
    setActiveConsultation(consultation) {
      if (this.activeConsultation && this.activeConsultation.id === consultation.id) {
        this.activeConsultation = null;
        return;
      }

      this.activeConsultation = consultation;
    },
  },
};
</script>

<style lang="scss" scoped>

.consultations-info {
  display: flex;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #E0E0E0;
  overflow: auto;
  box-sizing: border-box;
  height: 100%;
}

.consultations-list {
  height: 100%;
  overflow: auto;
  width: 280px;
  border-right: 1px solid #E0E0E0;
  box-sizing: border-box;
  flex-shrink: 0;
}

.no-consultations {
  padding: 30px 15px 30px 30px;
  font-size: 16px;
  line-height: 20px;
  color: #908F8D;
}

.no-active-consultation {
  box-sizing: border-box;
  padding: 20px;
  flex: 1;
  display: flex;
  height: 100%;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  align-items: center;
}
</style>
